import isInteger from 'lodash/isInteger';
import uuid from 'uuid/v1';

import * as c from '../constants';




export function assembleHotkeyTemplate(arr, parentGroup, isEditMode = false) {
  // This is a mix of hotkey_group, items, and hotkey_template_groups
  // Concat the add doc to the list
  return (arr.concat(c.ADD_DOC)|| []).map((d, i) => {
    if (d.id === c.ADD_DOC_ID) {
      return assembleAddTemplate(d, i, parentGroup);
    }

    if (d.doc_type === c.DOC_TYPE_HOTKEY_TEMPLATE_GROUP) {
      return d;
    }

    return (d.doc_type === c.DOC_TYPE_ITEM)
      ? assembleItemToTemplate(d, i, parentGroup, isEditMode)
      : assembleGroupToTemplate(d, i, parentGroup, isEditMode);
  });
}




export function assembleItemToTemplate(doc, position, parentGroup, isEditMode = false) {
  const { level = -1, is_default = false, id: parentGroupId } = parentGroup || {};
  const { name, image_url, is_template_group, active, id: itemId, position: dPosition } = doc;
  const id = uuid();
  const key = itemId;

  return {
    id,
    name,
    image_url,
    key,
    group: null,
    level: level + 1,
    active: is_default || active || !isEditMode,
    parent_id: parentGroupId,
    position: (isInteger(dPosition)) ? dPosition : position,
    is_group: false,
    is_class: false,
    key_level: `${level + 1}::${key}`,
    breadcrumbs: assembleBreadcrumbs(id, key, name, parentGroup),
    classification: null,
    is_template_group: is_template_group || false,
    item_id: itemId,
    parent: parentGroup
  }
}




export function assembleGroupToTemplate(doc, position, parentGroup, isEditMode = false) {
  const { level = -1, is_template_group = false, is_default: pIsDefault = false, id: parentGroupId } = parentGroup || {};
  const { id: groupId, name, image_url, classification_id, is_class, is_default = true } = doc;
  const id = uuid();
  const key = groupId;
  
  return {
    id,
    name,
    position,
    is_class,
    image_url,
    is_default,
    classification_id,
    is_template_group,
    key,
    item: null,
    level: level + 1,
    active: pIsDefault || !isEditMode,
    parent_id: parentGroupId,
    is_group: true,
    key_level: `${level + 1}::${key}`,
    breadcrumbs: assembleBreadcrumbs(id, key, name, parentGroup),
    group_id: key,
  }
}




export function assembleAddTemplate(data, position, parentGroup) {
  const { id: parentGroupId } = parentGroup || {};
  const { id } = data;
  const name = 'Add';

  return {
    id,
    name,
    position,
    key: id,
    parent_id: parentGroupId,
    active: false,
    is_group: true,
    breadcrumbs: assembleBreadcrumbs(parentGroupId, id, name, parentGroup),
    image_url: '',
    is_class: false,
    classification: null,
    is_template_group: false,
    item: null,
    level: null,
    group_id: null,
  }
}




export function assembleBreadcrumbs(id, key, name, parent) {
  const { level = -1, breadcrumbs = [] } = parent || {};

  if (key === c.ADD_DOC_ID) {
    return breadcrumbs;
  }
  
  return breadcrumbs.concat({
    hotkey_template_group_id: id,
    name,
    key,
    level: level + 1,
    key_level: `${level + 1}::${key}`
  })
}
